import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

import {
  MaterializeLabelFixDirective,
  CharacterCounterDirective,
  MaterialChipDirective,
  CollapsibleDirective,
  MaterialSelectDirective,
  ModalDirective,
  ModalBackdropService,
  SideNavDirective,
  TabsDirective
} from './directives';

/**
 * Replaces angular2-materialize with Angular Material + custom directives.
 * Use this module wherever MaterializeModule was used.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatExpansionModule,
    MatSelectModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  declarations: [
    ModalDirective,
    CharacterCounterDirective,
    TabsDirective,
    CollapsibleDirective,
    MaterialSelectDirective,
    SideNavDirective,
    MaterialChipDirective,
    MaterializeLabelFixDirective
  ],
  exports: [
    ModalDirective,
    CharacterCounterDirective,
    TabsDirective,
    CollapsibleDirective,
    SideNavDirective,
    MaterialSelectDirective,
    MaterialChipDirective,
    MaterializeLabelFixDirective,
    MatTabsModule,
    MatExpansionModule,
    MatSelectModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  providers: [ModalBackdropService]
})

export class SharedMaterializeModule { }
